import React from "react";
import {
  TextField,
  MenuItem,
  Box,
  Chip,
  Stack,
  IconButton,
  InputAdornment,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

const inputTypes = [
  { label: "Single Select (Dropdown)", value: "select" },
  { label: "Single Select (Radio Buttons)", value: "radio" },
  { label: "Multi Select (Dropdown)", value: "multiselect" },
  { label: "Multi Select (Checkboxes)", value: "checkbox" },
  { label: "Multi Select Quantified", value: "multiselect-quantified" },
  { label: "Free Text Input", value: "text" },
  { label: "Number Input", value: "number" },
  { label: "Color Picker (Text)", value: "color" },
];

const AccessoryCustomizationField = ({ customizationOptions, onChange }) => {
  const handleOptionAdd = (e) => {
    e.preventDefault();
    const newOption = e.target.option.value.trim();
    if (!newOption || customizationOptions.options.includes(newOption)) return;

    onChange({
      ...customizationOptions,
      options: [...customizationOptions.options, newOption],
    });
    e.target.option.value = "";
  };

  const handleOptionRemove = (optionToRemove) => {
    onChange({
      ...customizationOptions,
      options: customizationOptions.options.filter(
        (opt) => opt !== optionToRemove
      ),
    });
  };

  const isOptionType = ["select", "multiselect", "radio", "checkbox"].includes(
    customizationOptions.type
  );

  const generateKeyFromLabel = (label) =>
    label
      .toLowerCase()
      .replace(/\s+/g, "_")
      .replace(/[^a-z0-9_]/g, "");

  return (
    <Box
      sx={{
        border: "1px solid #ddd",
        borderRadius: 2,
        p: 2,
        mb: 2,
        backgroundColor: "#f9f9f9",
      }}>
      {/* Label */}
      <TextField
        fullWidth
        label="Customization Label"
        value={customizationOptions.label}
        onChange={(e) => {
          const newLabel = e.target.value;
          const generatedKey = generateKeyFromLabel(newLabel);

          onChange({
            ...customizationOptions,
            label: newLabel,
            key: generatedKey, // 💥 set key automatically
          });
        }}
        sx={{ mb: 2 }}
      />

      {/* Type Selector */}
      <TextField
        fullWidth
        label="Field Type"
        select
        value={customizationOptions.type}
        onChange={(e) =>
          onChange({ ...customizationOptions, type: e.target.value })
        }
        sx={{ mb: 2 }}>
        {inputTypes.map((type) => (
          <MenuItem key={type.value} value={type.value}>
            {type.label}
          </MenuItem>
        ))}
      </TextField>

      {/* Required Checkbox */}
      <FormControlLabel
        control={
          <Checkbox
            checked={customizationOptions.required || false}
            onChange={(e) =>
              onChange({ ...customizationOptions, required: e.target.checked })
            }
          />
        }
        label="Required Field"
        sx={{ mb: 2 }}
      />

      {/* Option Management */}
      {isOptionType && (
        <>
          <form onSubmit={handleOptionAdd}>
            <TextField
              label="Add Option"
              name="option"
              size="small"
              fullWidth
              placeholder="e.g. Pink, Blue, Gold"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton type="submit">
                      <AddIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </form>

          <Stack direction="row" spacing={1} sx={{ mt: 2 }} flexWrap="wrap">
            {customizationOptions.options.map((opt) => (
              <Chip
                key={opt}
                label={opt}
                onDelete={() => handleOptionRemove(opt)}
                deleteIcon={<DeleteIcon />}
                sx={{ backgroundColor: "#eee" }}
              />
            ))}
          </Stack>
        </>
      )}
    </Box>
  );
};

export default AccessoryCustomizationField;
